import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../../store';
import { RealtorDemand } from './RealtorDemand';
import { closeForm, openForm, trackInViewPort } from '../../../actions/requestDemand';
import {
  selectIsDemandRequestOpen,
  selectIsSmsVerificationModalOpen,
  selectIsSuccessModalOpen,
} from '../../../selectors/requestDemand';
import { selectOffer } from '../../../components/CostEstimate/selectors/selectOffer';
import { getOfferText } from './getOfferText';
import { EDemandBlockTypes } from '../../../constants/requestDemand';

export const mapStateToProps = (state: IState) => {
  const offer = selectOffer(state);

  return {
    text: getOfferText(offer),
    isSuccessModalOpen: selectIsSuccessModalOpen(state),
    isDemandRequestOpen: selectIsDemandRequestOpen(state),
    isSmsVerificationModalOpen: selectIsSmsVerificationModalOpen(state),
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<IState>) => ({
  openDemandRequest() {
    dispatch(openForm());
  },
  closeDemandRequest() {
    dispatch(closeForm());
  },
  onShownInViewPort(visible: boolean) {
    dispatch(trackInViewPort(EDemandBlockTypes.DEMAND, visible));
  },
});

export const RealtorDemandContainer = connect(mapStateToProps, mapDispatchToProps)(RealtorDemand);
